module.exports = __webpack_public_path__ + "dashboard/img/questionnaire.0708895e42000f9153ba58bb3c739a69.svg";